import { Outlet } from "react-router-dom";

import Providers from "@/providers";

export function AppProvidersLayout() {
  return (
    <Providers>
      <Outlet />
    </Providers>
  );
}
